module.exports = __webpack_public_path__ + "static/OldMansJourney5-b775f0aa06ba05649b98d0ea869034ab.webp";